import type { RepositoryDetails } from '../../types/analysis.types';

export const vibeMapperRepositoryDetails: RepositoryDetails = {
  description:
    'Open-source platform that orchestrates cloud-native deployments, real-time observability, and machine learning pipelines into a unified developer experience.',
  keyTechnologies: [
    'TypeScript',
    'React',
    'Node.js',
    'Express',
    'Prisma',
    'Python',
    'Temporal',
    'Terraform',
    'Docker',
    'Kubernetes',
    'HashiCorp Vault',
    'PostgreSQL',
    'Playwright',
  ],
  projectType: 'full-stack platform',
  secondaryTypes: ['infrastructure-as-code', 'ai-ml-pipeline'],
  projectTypeConfidence: 0.92,
  packageManagers: ['pnpm', 'pip', 'poetry'],
  testingFrameworks: ['Playwright', 'pytest', 'Vitest'],
  runtimeDepsCount: 245,
  devDepsCount: 125,
  cicdPlatform: 'GitLab CI',
  capabilities: ['Docker', 'Kubernetes'],
  iacTools: ['Terraform', 'Helm'],
  documentation: {
    hasReadme: true,
    hasChangelog: true,
    hasContributing: true,
    hasApiDocs: false,
    docsCount: 28,
  },
  versionControl: {
    platform: 'GitLab',
    defaultBranch: 'main',
    recentCommitCount: 796,
  },
};
